export default __webpack_public_path__ + "static/media/online.94913080.svg";